<div class="special-charts-wrapper">
  <div class="card card--donut">
    <div class="card__header">
      <div class="card__title">
        {{ 'specialUsers.yourCommunity' | translate }}
      </div>
    </div>

    <div class="card__body card__body--center">
      <div class="donut-chart-container">
        <div class="donut-chart-container__chart">
          <apx-chart
            appHideApexChartTooltipOnScroll
            [series]="donutChartOptions().series"
            [labels]="donutChartOptions().labels"
            [chart]="donutChartOptions().chart"
            [colors]="donutChartOptions().colors"
            [plotOptions]="donutChartOptions().plotOptions"
            [dataLabels]="donutChartOptions().dataLabels"
            [fill]="donutChartOptions().fill"
            [stroke]="donutChartOptions().stroke"
            [legend]="donutChartOptions().legend"
            [tooltip]="donutChartOptions().tooltip"
            [states]="donutChartOptions().states"
          ></apx-chart>

          <div class="donut-chart-container__center">
            <div class="donut-chart-container__value">{{ totalCommunitySize() }}</div>
            <div class="donut-chart-container__label">
              {{ 'specialUsers.community' | translate }}
            </div>
          </div>
        </div>

        <div class="donut-chart-container__legend">
          <div class="legend-item">
            <span class="legend-item__dot legend-item__dot--primary"></span>
            <span class="legend-item__text">
              {{ 'specialUsers.ganarbols' | translate }}
            </span>
          </div>
          <div class="legend-item">
            <span class="legend-item__dot legend-item__dot--secondary"></span>
            <span class="legend-item__text">
              {{ 'specialUsers.ganacuates' | translate }}
            </span>
          </div>
          <div class="legend-item">
            <span class="legend-item__dot legend-item__dot--tertiary"></span>
            <span class="legend-item__text">
              {{ 'specialUsers.ganasocios' | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="card__footer card__footer--center">
      <span class="footer-text">
        {{ 'specialUsers.vsLastWeek' | translate: { count: 4 } }}
      </span>
      <span class="footer-icon footer-icon--up">
        <i>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path
              d="M13.7489 6L21.3027 6.00052L21.403 6.01444L21.5018 6.04205L21.5621 6.0676C21.6413 6.10246 21.7155 6.15315 21.7808 6.21836L21.8215 6.2624L21.865 6.31878L21.9192 6.4089L21.9579 6.49922L21.977 6.5633L21.9906 6.6273L22 6.7215L22.0004 14.2539C22.0004 14.6681 21.6647 15.0039 21.2504 15.0039C20.8708 15.0039 20.557 14.7217 20.5073 14.3557L20.5004 14.2539L20.5 8.559L12.7812 16.2793C12.5149 16.5455 12.0982 16.5698 11.8046 16.3519L11.7205 16.2793L8.75001 13.3089L3.28033 18.7786C2.98744 19.0715 2.51256 19.0715 2.21967 18.7786C1.9534 18.5123 1.9292 18.0957 2.14705 17.8021L2.21967 17.7179L8.21967 11.7179C8.48593 11.4517 8.90259 11.4275 9.1962 11.6453L9.28032 11.7179L12.2508 14.6883L19.438 7.5H13.7489C13.3692 7.5 13.0554 7.21785 13.0058 6.85177L12.9989 6.75C12.9989 6.3703 13.2811 6.05651 13.6472 6.00685L13.7489 6Z"
              fill="#078339"
            />
          </svg>
        </i>
      </span>
    </div>
  </div>

  <div class="card card--line">
    <div class="card__header">
      <div class="card__title text-center md:text-left">
        {{ 'specialUsers.referralGrowth' | translate }}
      </div>
      <div class="card__subtitle text-center md:text-left">
        {{ 'specialUsers.lastMonths' | translate: { count: 6 } }}
      </div>
    </div>
    <div class="card__body">
      @if (referralGrowthResource.status() === 'error') {
        <app-resource-load-error data-resource="growth" (retry)="referralGrowthResource.reload()" />
      } @else if (referralGrowthResource.hasValue()) {
        <apx-chart
          class="line-chart"
          [series]="lineChartOptions().series"
          [chart]="lineChartOptions().chart"
          [xaxis]="lineChartOptions().xaxis"
          [yaxis]="lineChartOptions().yaxis"
          [stroke]="lineChartOptions().stroke"
          [dataLabels]="lineChartOptions().dataLabels"
          [markers]="lineChartOptions().markers"
          [colors]="lineChartOptions().colors"
          [grid]="lineChartOptions().grid"
          [legend]="lineChartOptions().legend"
          [states]="lineChartOptions().states"
        ></apx-chart>
      }
    </div>

    <div class="card__footer card__footer--legend">
      <div class="legend-item">
        <span class="legend-item__dot legend-item__dot--orange"></span>
        <span class="legend-item__text">
          {{ 'specialUsers.sent' | translate }}
        </span>
      </div>
      <div class="legend-item">
        <span class="legend-item__dot legend-item__dot--primary"></span>
        <span class="legend-item__text">
          {{ 'specialUsers.registered' | translate }}
        </span>
      </div>
      <div class="legend-item">
        <span class="legend-item__dot legend-item__dot--green"></span>
        <span class="legend-item__text">
          {{ 'specialUsers.cardActivations' | translate }}
        </span>
      </div>
    </div>
  </div>
</div>
